// page init
import 'jquery-mask-plugin';
import 'jquery-validation';
import Handlebars from '../libraries/handlebars';
import getRelatedProducts from './getRelatedProducts';
import jcf from '../libraries/jcf/jcf';
import calculateTotal from './checkout/calculateTotal';
import productCarousel from "./productCarousel";
import intlTelInput from 'intl-tel-input';
import translations from '../translations';
import getCurrencyCode from './getCurrencyCode';

export default function checkout () {
    calculateTotal();
    /********************
     ***** CHECKOUT *****
     ********************/


    var siteLanguage = window.location.pathname.split('/')[1];
    var phoneNumberMask = '00 000-00-00-00-00';
    $('input[name="Phone"]').mask(phoneNumberMask); //+xxx xx xxx-xx-xx
    $('input[name="RecieverPhone"]').mask(phoneNumberMask);
    $('input[name="Department"]').mask('№00000');

    $('.checkout-address-form').submit(function () {
        $('.checkout-address-form input').addClass('disabled');
        $('.checkout-address-form textarea').addClass('disabled');
    });

    /******************
     ***** BASKET *****
     ******************/



    function modifierInputPhoneNumber(oldPhoneNumberControl) {
        var parent = oldPhoneNumberControl.parentNode;
        var visualPhoneInputField = oldPhoneNumberControl.cloneNode();
        oldPhoneNumberControl.classList.add("hidden");
        visualPhoneInputField.setAttribute("id", "visual-phone-number");
        visualPhoneInputField.setAttribute("name", "visual-phone-number");
        parent.appendChild(visualPhoneInputField);
        $('input[name="visual-phone-number"]').mask('z0 000-00-00', {'translation': {z: {pattern: /[1-9*]/}}}); //+xxx xx xxx-xx-xx

        var phoneInput = intlTelInput(visualPhoneInputField, {
            preferredCountries: ["ua", "pl"],
            separateDialCode: true,
            autoPlaceholder: "Phone code",
            geoIpLookup: function(success, failure) {
                $.get("https://ipinfo.io", function() {}, "jsonp").always(function(resp) {
                    var countryCode = (resp && resp.country) ? resp.country : "us";
                    success(countryCode);
                });
            },
            utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
        });
        if(oldPhoneNumberControl) {
            function setValue() {
                var phone = phoneInput.getNumber();
                phone = phone.replaceAll("-", "").replaceAll(" ", "")

                if (phone.includes("+1")) {
                    $(phoneInput.telInput).mask('z00 000-00-00', {'translation': {z: {pattern: /[1-9*]/}}});
                } else if(phone.includes("+49")) {
                    $(phoneInput.telInput).mask('z00 000-000-00', {'translation': {z: {pattern: /[1-9*]/}}});
                } else {
                    $(phoneInput.telInput).mask('z0 000-00-00', {'translation': {z: {pattern: /[1-9*]/}}});
                }

                if (phone.includes("+380380")) {
                    var newPhone = phone.replaceAll("+380380", '');

                    visualPhoneInputField.value = newPhone;
                    $(visualPhoneInputField).trigger("input");

                    oldPhoneNumberControl.value = '+380' + newPhone;
                }
                else {
                    oldPhoneNumberControl.value = phone;
                }
            }

            visualPhoneInputField.addEventListener("input", () => {
                setValue();
            });

            visualPhoneInputField.addEventListener("countrychange", function() {
                setValue();
            });
        }
    }

    var phoneInputField = document.querySelector('#Phone');
    if(phoneInputField) {
        modifierInputPhoneNumber(phoneInputField);
    }

    var reciverPhoneNumberField = document.querySelector("#RecieverPhone");
    if(reciverPhoneNumberField) {
        modifierInputPhoneNumber(reciverPhoneNumberField)
    }

    if (!$('#checkout-form')) return;

    $('[data-muifrm="basket"]').on('keyup keypress', function (e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
            e.preventDefault();
            return false;
        }
    });

    function updateFieldsFormShowPopUp(htmlSelectElement) {
        var sku = $(htmlSelectElement).data('sku');
        var price = $(htmlSelectElement).data('price');

        $('div.contact-popup').find('input[name=Sku]').first().val(sku);
        $('div.contact-popup').find('input[name=ProductPrice]').first().val(price);
    }

    $(document).on('click', '.showPopUp', function () {
        updateFieldsFormShowPopUp(this);

        $('.contact-popup').show();
        $('#contactPopUp:hidden').show();
    });

    function clearPopupInputs() {
        $('.contact-popup-form').find('input').each(function () {
            $(this).val('');
            $(this).removeClass('input-validation-error')
        });
    }

    function hideFormPopUp() {
        clearPopupInputs();
        $('.contact-popup').hide();
        $('.contact-popup .contact-popup-message').removeClass('show');
        $('.contact-popup .contact-popup-error').removeClass('show');
        $('.contact-popup-form').removeClass('hidden');
    }

    $('.contact-popup-close, .contact-popup-message .btn').on('click', function () {
        hideFormPopUp();
    });

    var errorMessage = $('.contact-popup-error');

    $("#ContactForm input").on('input', function() {
       $(this).removeClass('input-validation-error');
        errorMessage.removeClass('show');
    });

    $("#ContactForm").submit(function (e) {
        var model = $(this).serializeArray();
        var isRequired = false;

        $(this).find('.contact-popup-row input').each(function () {
            if ($(this).val().length == 0) {
                isRequired = true;
                errorMessage.addClass('show');
                return false;
            } else {
                isRequired = false;
                return true;
            }
        });

        if (isRequired) {
            return;
        }

        e.preventDefault();
        $('.contact-popup-btn-holder button').prop('disabled', true);

        $.ajax({
            type: 'POST',
            url: '/umbraco/api/products/AddCustomerToMailingList',
            dataType: 'json',
            data: model,
            success: function () {
                $('.contact-popup-btn-holder button').prop('disabled', false);

                clearPopupInputs();
                $('.contact-popup .contact-popup-message').addClass('show');
                $('.contact-popup-form').addClass('hidden');

            }
        });
    });

    $('[name=delivery-selector]').click(function () {
        $('#delivery').val($(this).attr('data-value'));
    });
    $('[name=payment-selector]').click(function () {
        $('#paymentMethod').val($(this).attr('data-value'));
    });
    $('[name=reciever-selector]').click(function () {
        $('#reciever').val($(this).attr('data-value'));
    });

    $('[name=PreferredMessenger]').on('change', function (e) {
        if (e.target.value === 'Telegram') {
            $('.telegram-input').show();
        }
        else {
            $('.telegram-input').hide();
        }

        const validator = $("#checkout-form").validate();

        validator.element("#Instagram");
        validator.element("#Telegram");
    });

    $('#hasPromoCode').click(function () {
        $("#promoCodeInput").toggle();

        var isUnchecked = !this.checked;
        if (isUnchecked) {
            $(".check-mark").hide();
            $(".incorrect-promo-code-label").hide();
            $(".promo-code-total-container").hide();
            $('#promoCodeInput').val('');
            $(".total-td").removeClass('basket-old-price');
        }

        setCheckedPromoCode(this.checked);
    });

    var basket;

    $(document).ready(function () {

        if ($('#viewed-product').length > 0) {
            ViewedProduct();
        }

        var promoCode = $("#PromoCode");

        if (promoCode.length > 0 && !!promoCode[0]) {
            promoCode[0].defaultValue = "";
        }


        if ($('#DisableCardPay').length > 0) {
            var parent = $('.checkout-address-form .delivery__holder');
            var item = parent.find('.delivery__item');
            $(':radio[data-value="Fondy"]').prop('disabled', true);
            $(':radio[data-value="Fondy"]').closest(item).addClass('disabled');
        }

        getRelatedProducts();

        $.ajax({
            url: '/umbraco/Surface/Basket/GetBasket',
            type: 'GET',
            success: function (data) {
                basket = data;
            }
        });
    });

    function ViewedProduct() {
        try {
            var productCookie = $('#relateProductBlock').data("product");
            var productLocalStore = localStorage.getItem("ViewedProduct");

            var relateProductsContainer = $('#relateProductBlock');
            var product = {};

            if ($('.product').length > 0) {

                if (!productCookie) {
                    relateProductsContainer.hide();
                    return;
                }

                product = productCookie;

                if (!product) {
                    return;
                }
            }

            var viewProduct = [];
            var siteLanguage = getCurrentLanguage();

            if (!productLocalStore) {
                productLocalStore = [];
                productLocalStore.push(product);
                viewProduct = productLocalStore;
            }
            else if (Object.keys(product).length !== 0) {
                productLocalStore = JSON.parse(productLocalStore);

                if (productLocalStore.filter(i => i.url == product.url).length === 0) {

                    productLocalStore.push(product);

                }
            }
            else {
                productLocalStore = JSON.parse(productLocalStore);
            }

            localStorage.setItem("ViewedProduct", JSON.stringify(productLocalStore));

            viewProduct = productLocalStore.filter(p => {
                var date = new Date(p.dateAdded);
                date.setDate(date.getDate() + 1);
                return p.culture.includes(siteLanguage) && date >= Date.now()
            });
            viewProduct = viewProduct.sort(function (a, b) {
                var dateA = new Date(a.dateAdded);
                var dateB = new Date(b.dateAdded);

                return dateB - dateA;
            });

            var productAmount = window.innerWidth < 768 ? 12 : 10;

            var take = viewProduct.length > productAmount ? productAmount : viewProduct.length;

            viewProduct = viewProduct.slice(0, take + 1);
            viewProduct = viewProduct.sort(function (a, b) {
                return b.availability ? 1 : a.availability ? -1 : 1;
            });

            if ($('.product').length > 0) {
                viewProduct = viewProduct.filter(p => p.url != decodeURI(window.location.pathname));
            }
            else if (window.location.href.includes("basket")) {
                viewProduct = viewProduct.filter(p => $("td > a[href=\"" + p.url + "\"]").length == 0);
            }

            if (viewProduct.length === 0) {
                $('#relateProductBlock').hide();
                return;
            }

            var template = $("#viewed-product").html();
            var handeleBarTemplate = Handlebars.compile(template);
            var html = handeleBarTemplate(viewProduct);
            $('#relateProductBlock').append(html);
            productCarousel();
            //productCarousel($('#relateProductBlock .product-list.swiper'));
        }
        catch (e) {
            localStorage.removeItem("ViewedProduct");
        }
    }

    $('.js-promo-code').click(function (e) {
        var inputField = $('.js-promo-code-input');
        checkPromoCode(inputField.val());
    });

    $('.js-submit-checkout').click(function (e) {
        $('#LoadingPoupUp').show();

        $(this).attr("disabled", true);

        $("#Comment").val($('#Comment3').val());

        var form = $('.checkout-address-form');
        if (form) {
            form.submit();
        }
    });

    if ($('#checkout-form').data('validator')) {
        $('#checkout-form').data('validator').destroy();
    }

    // heckout validation (rules and messages)
    $('#checkout-form').validate({
        rules: {
            'FirstName': {
                required: true,
                minlength: 2,
                regexString: true
            },
            'LastName': {
                required: true,
                minlength: 2,
                regexString: true
            },
            'Phone': {
                required: true,
            },
            'visual-phone-number': {
                required: true,
            },
            'Email': {
                regexPattern: true,
                required: true,
                email: true
            },
            'Telegram': {
                required: function (element) {
                    return $('[name=PreferredMessenger]').val() === 'Telegram';
                },
                minlength: 2
            },
            'Instagram': {
                required: function (element) {
                    return $('[name=PreferredMessenger]').val() === 'Instagram';
                }
            },
            'Street': {
                required: true,
                minlength: 2
            },
            'Region': {
                required: true,
                minlength: 2
            },
            'HouseNumber': {
                required: true
            },
            'City': {
                required: true,
                minlength: 2,
                regexString: true
            },
            'Department': {
                required: true,
                regex: '^(/?.*[0-9])$'
            },
            'NovaPoshtaMailboxAddress' :{
                required: true,
                minlength: 3,
                chooseAdress: true,
            },
            'NovaPoshtaOfficeAddress' :{
                required: true,
                minlength: 3,
                chooseAdress: true,
            },
            'NovaPoshtaDeliveryAddress' :{
                required: true,
                minlength: 3,
                chooseAdress: true,
            },
            'NovaPoshtaMailboxDepartment':{
                required: true,
                chooseMailbox: true,
            },
            'NovaPoshtaOfficeDepartment':{
                required: true,
                chooseOffice: true,
            },
            'NovaPoshtaDeliveryStreet': {
                required: true,
                chooseStreet: true,
            },
            'RecieverFirstName': {
                required: true,
                minlength: 2,
                regexString: true
            },
            'RecieverLastName': {
                required: true,
                minlength: 2,
                regexString: true
            },
            "Index": {
                required: true
            },
            'RecieverPhone': {
                required: true,
            },
        },
        messages: {
            'FirstName': {
                required: translations.requiredField[getLanguageForTranslations()],
                minlength: translations.minLengthTwo[getLanguageForTranslations()],
            },
            'LastName': {
                required: translations.requiredField[getLanguageForTranslations()],
                minlength: translations.minLengthTwo[getLanguageForTranslations()],
            },
            'Phone': {
                required: translations.requiredField[getLanguageForTranslations()],
                regex: translations.regexPhone[getLanguageForTranslations()],
                minlength: translations.requiredPhone[getLanguageForTranslations()],
            },
            'Email': {
                required: translations.requiredField[getLanguageForTranslations()],
                email: translations.regexEmail[getLanguageForTranslations()],
            },
            'Telegram': {
                required: translations.requiredField[getLanguageForTranslations()],
                minlength: translations.requiredTelegram[getLanguageForTranslations()],
            },
            'Instagram': {
                required: translations.requiredField[getLanguageForTranslations()],
            },
            'Street': {
                required: translations.requiredField[getLanguageForTranslations()],
                minlength: translations.minLengthTwo[getLanguageForTranslations()],
            },
            'Region': {
                required: translations.requiredField[getLanguageForTranslations()],
                minlength: translations.minLengthTwo[getLanguageForTranslations()],
            },
            'HouseNumber': {
                required: translations.requiredField[getLanguageForTranslations()],
                regex: translations.requiredField[getLanguageForTranslations()],
            },
            'FlatNumber': {
                regex: translations.startWithNumber[getLanguageForTranslations()],
            },
            'City': {
                required: translations.requiredField[getLanguageForTranslations()],
                minlength: translations.minLengthTwo[getLanguageForTranslations()],
            },
            'Department': {
                required: translations.requiredField[getLanguageForTranslations()],
                regex: translations.enterNumber[getLanguageForTranslations()],
            },
            'NovaPoshtaMailboxAddress':{
                required: translations.requiredField[getLanguageForTranslations()],
                minlength: translations.minLengthThree[getLanguageForTranslations()],
            },
            'NovaPoshtaOfficeAddress':{
                required: translations.requiredField[getLanguageForTranslations()],
                minlength: translations.minLengthThree[getLanguageForTranslations()],
            },
            'NovaPoshtaDeliveryAddress':{
                required: translations.requiredField[getLanguageForTranslations()],
                minlength: translations.minLengthThree[getLanguageForTranslations()],
            },
            'NovaPoshtaMailboxDepartment':{
                required: translations.requiredField[getLanguageForTranslations()],
            },
            'NovaPoshtaOfficeDepartment':{
                required: translations.requiredField[getLanguageForTranslations()],
            },
            'NovaPoshtaDeliveryStreet': {
                required: translations.requiredField[getLanguageForTranslations()],
            },
            'RecieverFirstName': {
                required: translations.requiredField[getLanguageForTranslations()],
                minlength: translations.minLengthTwo[getLanguageForTranslations()],
            },
            'RecieverLastName': {
                required: translations.requiredField[getLanguageForTranslations()],
                minlength: translations.minLengthTwo[getLanguageForTranslations()],
            },
            'RecieverPhone': {
                required: translations.requiredField[getLanguageForTranslations()],
                regex: translations.regexPhone[getLanguageForTranslations()],
                minlength: translations.requiredPhone[getLanguageForTranslations()],
            },
            'Index': {
                required: translations.requiredField[getLanguageForTranslations()],
            }
        },
        /*errorClass: 'error-name',
        errorPlacement: function (err, element) {
            err.insertBefore(element);
        },*/
    });

    $.validator.addMethod("regexPattern", function (value, element) {
        return this.optional(element) || /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value);
    }, translations.regexEmail[getLanguageForTranslations()]);

    $.validator.addMethod("regexString", function (value, element) {
        return this.optional(element) || /^([a-zA-Zа-яА-ЯҐЄІЇ ]{1,})+\-?([a-zA-Zа-яґєіїА-ЯҐЄІЇ ]{1,})$/.test(value.trim());
    }, translations.regexString[getLanguageForTranslations()]);

    $.validator.addMethod("chooseAdress", function (value, element) {
        return this.optional(element) || $(element).attr('data-ref');
    }, translations.chooseAdress[getLanguageForTranslations()]);

    $.validator.addMethod("chooseMailbox", function (value, element) {
        return this.optional(element) || $(element).attr('data-ref');
    }, translations.chooseMailbox[getLanguageForTranslations()]);

    $.validator.addMethod("chooseOffice", function (value, element) {
        return this.optional(element) || $(element).attr('data-ref');
    }, translations.chooseOffice[getLanguageForTranslations()]);

    $.validator.addMethod("chooseStreet", function (value, element) {
        return this.optional(element) || $(element).attr('data-ref');
    }, translations.chooseStreet[getLanguageForTranslations()]);

    /* page on load */
    const billingForm = new BillingForm('#checkout-form', {
        exceptedFields: ["__RequestVerificationToken", "ufprt"],
        storageName: "checkoutForm"
    });

    checkRadioState();
};

function getCurrentLanguage() {
    var siteLanguage = ''

    switch (window.location.pathname.split('/')[1]) {
        case 'ru':
            siteLanguage = 'ru-RU';
            break;
        case 'en':
            siteLanguage = "en-US"
            break;
        case 'pl':
            siteLanguage = "pl-PL"
            break;
        case 'es':
            siteLanguage = "es-ES"
            break;

        default:
            siteLanguage = "uk-UA";
            break;
    }

    return siteLanguage;
}

function getLanguageForTranslations() {
    return getCurrentLanguage().split('-')[0];
}

function checkRadioState() {

    var parent = $('.checkout-address-form .delivery__holder');

    if (!parent) return;

    var item = parent.find('.delivery__item');
    var radios = item.find('input[type="radio"]');
    var activeClass = 'active';
    var paymentSection = $('.js-payment');
    var deliverySection = $('.js-delivery');

    radioRelations();

    radios.on('change', function () {
        $(this).closest(parent).find('.delivery__item').each(function () {
            $(this).removeClass(activeClass);

            var textarea = $(this).find('textarea');
            if (textarea) textarea.val('');

            $(this).find('input').not(':radio, :checkbox').each(function () {
                $(this).val('').attr("data-ref", "");
                //$(this).removeClass("error");
            });

            $(this).find('input').not(':radio, :checkbox, .ignore').each(function () {
                $(this).prop('disabled', true);
            });

            $(this).find('input.ignore').each(function(){
                if(!$(this).attr("data-ref")) {
                    $(this).prop('disabled', true);
                }
            });
        });

        $(this).closest(item).addClass(activeClass);
        $(this).closest(item).find('input').not(':radio, :checkbox, .ignore').each(function () {
            $(this).prop('disabled', false);
        });
    });

    radios.each(function () {
        if ($(this).is(':checked')) {
            $(this).closest(item).addClass(activeClass);
            $(this).closest(item).find('input').not(':radio, :checkbox, .ignore').each(function () {
                $(this).prop('disabled', false);
            });
        } else {
            $(this).parent(item).removeClass(activeClass);
            $(this).closest(item).find('input').not(':radio, :checkbox, .ignore').each(function () {
                $(this).prop('disabled', true);
            });
        }
    });

    deliverySection.find('input[type="radio"]').on('change', function () {
        $(this).on('change', function () {
            paymentSection.find('.delivery__item.disabled.active').each(function () {
                $(this).removeClass('active');
            });
        });

        paymentSection.find('input[type="radio"]').each(function () {
            $(this).prop('disabled', false);
            $(this).closest(item).removeClass('disabled');
            $(this).prop('checked', false);

            if ($(this).attr('data-value') === 'Liqpay') {
                $(this).prop('checked', true);
            }

            var activeAndDisabledEl = paymentSection.find('.delivery__item.disabled.active');

            if (jcf && activeAndDisabledEl.length > 0) {
                jcf.refreshAll('#checkout-form');
            }

        });

        radioRelations();

        item.each(function () {
            if ($(this).hasClass('disabled')) {
                jcf.refreshAll($(this));
            }
        });
    });

    function ResetPayment() {
        $("#paymentMethod").val("BankCard");
        $(":radio[data-value='Fondy']").attr('checked', false);
        $(":radio[data-value='Fondy']").parent().removeClass('jcf-checked');
        $(":radio[data-value='Fondy']").parent().addClass('jcf-unchecked');
        $(":radio[data-value='BankCard']").attr('checked', true);
        $(":radio[data-value='BankCard']").parent().removeClass('jcf-unchecked');
        $(":radio[data-value='BankCard']").parent().addClass('jcf-checked');
    }

    function radioRelations() {
        var isAllowCOD = parseInt($('.js-total-price').text(), 0) >= 300 && $('#DisablePayByCod').length <= 0;
        var isAllowPayByCard = parseInt($('.js-total-price').text(), 0) >= 200;
        var isDisablePayByCard = isAllowPayByCard ? $('#DisableCardPay').length > 0 : true;

        var checkRadio = function () {
            return radios.closest('.js-payment').find('input[type="radio"]');
        };

        var disablingRadio = function (radioItem) {
            radioItem.prop('disabled', true);
            radioItem.closest(item).addClass('disabled');
        };

        var checkEqual = function (radioItem, name) {
            return radioItem.attr('data-value') === name;
        };

        var isDisablePayByCardCase = (isDisablePayByCard ? '' : ':radio[data-value="Fondy"],') + ':radio[data-value="BankCard"]' + (isAllowCOD ? ', :radio[data-value="COD"]' : '');

        // Nova Poshta API integration
        function NovaPoshtaHandler(address='', mailbox='', office='', street='') {
            var addressInput;
            var addressDrop;
            var addressList;
            var activeClass = 'active';

            const novaPoshtaApiKey = process.env.NOVA_POSHTA_API_KEY;

            function findAddress(address) {
                $.post(
                    'https://api.novaposhta.ua/v2.0/json/',
                    JSON.stringify({
                        "apiKey": novaPoshtaApiKey,
                        "modelName": "Address",
                        "calledMethod": "searchSettlements",
                        "methodProperties": {
                            "CityName" : address,
                            "Limit" : "200",
                            "Page" : "1"
                        }
                    }),
                    function(data){
                        addressList.html('');
                        if(!data.data[0]?.Addresses.length) {
                            addressList.append('<li><span>Немає результатів</span></li>');
                        } else {
                            data.data[0].Addresses.forEach(function(item) {
                                addressList.append('<li><a href="#" data-ref="'+ item.DeliveryCity +'">'+ item.Present +'</a></li>');
                            });
                        }
                    }
                );
            }

            if(address) {
                addressInput = address;
                addressDrop = addressInput.closest('.input-item').find('.autocomplete__drop');
                addressList = addressDrop.find('.autocomplete__list');

                addressInput.on('focus', function() {
                    if(this.value.length >= 3) {
                        addressDrop.addClass(activeClass);
                    }
                });
                addressInput.on('blur', function() {
                    setTimeout(function() {
                        addressDrop.removeClass(activeClass);
                    },0)
                });
            }

            if(address && mailbox) {
                var mailboxInput = mailbox;
                var mailboxDrop = mailboxInput.closest('.input-item').find('.autocomplete__drop');
                var mailboxList = mailboxDrop.find('.autocomplete__list');

                addressInput.on('input', function() {
                    addressInput.attr('data-ref', '');
                    mailboxInput.attr('disabled', true);
                    mailboxInput.attr('data-ref', '');
                    mailboxInput.val('');

                    if($(this).val().length < 3) {
                        setTimeout(function() {
                            addressDrop.removeClass(activeClass);
                        },0)
                        return;
                    } else {
                        findAddress($(this).val());
                        addressDrop.addClass(activeClass);
                    }
                });

                addressList.on( "click", "a", function(e) {
                    e.preventDefault();
                    addressInput.val($(this).text());
                    addressInput.attr('data-ref', $(this).attr('data-ref'));
                    mailboxInput.attr('disabled', false);
                    mailboxInput.attr('data-ref', '');
                    mailboxInput.val('');
                    addressDrop.removeClass(activeClass);

                    $("#checkout-form").data("validator").currentElements.valid();
                });

                mailboxInput.on('focus', function(){
                    mailboxDrop.addClass(activeClass);
                    findMailbox(addressInput.attr('data-ref'));
                });

                mailboxInput.on('blur', function() {
                    setTimeout(function() {
                        mailboxDrop.removeClass(activeClass);
                    },0);
                });

                mailboxInput.on('input', function() {
                    mailboxInput.attr('data-ref', '');
                    findMailbox(addressInput.attr('data-ref'), this.value);
                });

                function findMailbox(CityRef, FindByString) {
                    var methodProperties = {
                        "TypeOfWarehouseRef" : "f9316480-5f2d-425d-bc2c-ac7cd29decf0",
                        "Limit" : "200",
                        "Page" : "1"
                    }

                    if(CityRef) {
                        methodProperties.CityRef = CityRef
                    }
                    if(FindByString) {
                        methodProperties.FindByString = FindByString
                    }

                    $.post(
                        'https://api.novaposhta.ua/v2.0/json/',
                        JSON.stringify({
                            "apiKey": "cd1636968f2a5dbb0ab40e326cf258de",
                            "modelName": "Address",
                            "calledMethod": "getWarehouses",
                            "methodProperties" : methodProperties
                        }),
                        function(data){
                            mailboxList.html('');
                            if(!data.data?.length) {
                                mailboxList.append('<li><span>Немає результатів</span></li>');
                            } else {
                                data.data.forEach(function(item) {
                                    mailboxList.append('<li><a href="#" data-ref="'+ item.SiteKey +'">'+ item.Description +'</a></li>');
                                });
                            }

                        }
                    );
                }

                mailboxList.on( "click", "a", function(e) {
                    e.preventDefault();
                    mailboxInput.val($(this).text());
                    mailboxInput.attr('data-ref', $(this).attr('data-ref'));
                    mailboxDrop.removeClass(activeClass);
                    $("#checkout-form").data("validator").currentElements.valid();
                });
            }

            if(address && office) {
                var officeInput = $('#NovaPoshtaOfficeDepartment');
                var officeDrop = officeInput.closest('.input-item').find('.autocomplete__drop');
                var officeList = officeDrop.find('.autocomplete__list');

                addressInput.on('input', function() {
                    addressInput.attr('data-ref', '');
                    officeInput.attr('disabled', true);
                    officeInput.attr('data-ref', '');
                    officeInput.val('');

                    if($(this).val().length < 3) {
                        setTimeout(function() {
                            addressDrop.removeClass(activeClass);
                        },0)
                        return;
                    } else {
                        findAddress($(this).val());
                        addressDrop.addClass(activeClass);
                    }
                });

                addressList.on( "click", "a", function(e) {
                    e.preventDefault();

                    addressInput.val($(this).text());
                    addressInput.attr('data-ref', $(this).attr('data-ref'));
                    officeInput.attr('disabled', false);
                    officeInput.attr('data-ref', '');
                    officeInput.val('');
                    addressDrop.removeClass(activeClass);
                    $("#checkout-form").data("validator").currentElements.valid();
                });

                officeInput.on('focus', function(){
                    officeDrop.addClass(activeClass);
                    findOffice(addressInput.attr('data-ref'));
                });

                officeInput.on('blur', function() {
                    setTimeout(function() {
                        officeDrop.removeClass(activeClass);
                    },0);
                });

                officeInput.on('input', function() {
                    officeInput.attr('data-ref', '');
                    findOffice(addressInput.attr('data-ref'), this.value);
                });

                function findOffice(CityRef, FindByString) {
                    var methodProperties = {
                        //"TypeOfWarehouseRef" : "841339c7-591a-42e2-8233-7a0a00f0ed6f",
                        "Limit" : "200",
                        "Page" : "1"
                    }

                    if(CityRef) {
                        methodProperties.CityRef = CityRef
                    }
                    if(FindByString) {
                        methodProperties.FindByString = FindByString
                    }

                    $.post(
                        'https://api.novaposhta.ua/v2.0/json/',
                        JSON.stringify({
                            "apiKey": "cd1636968f2a5dbb0ab40e326cf258de",
                            "modelName": "Address",
                            "calledMethod": "getWarehouses",
                            "methodProperties" : methodProperties
                        }),
                        function(data){
                            officeList.html('');
                            if(!data.data?.length) {
                                officeList.append('<li><span>Немає результатів</span></li>');
                            } else {
                                data.data.forEach(function(item) {
                                    if(item.CategoryOfWarehouse != "Postomat") {
                                        officeList.append('<li><a href="#" data-ref="'+ item.SiteKey +'">'+ item.Description +'</a></li>');
                                    }
                                });
                            }
                        }
                    );
                }

                officeList.on( "click", "a", function(e) {
                    e.preventDefault();
                    officeInput.val($(this).text());
                    officeInput.attr('data-ref', $(this).attr('data-ref'));
                    officeDrop.removeClass(activeClass);
                    $("#checkout-form").data("validator").currentElements.valid();
                });
            }

            if(address && street) {
                var streetInput = $('#NovaPoshtaDeliveryStreet');
                var streetDrop = streetInput.closest('.input-item').find('.autocomplete__drop');
                var streetList = streetDrop.find('.autocomplete__list');

                addressInput.on('input', function() {
                    addressInput.attr('data-ref', '');
                    streetInput.attr('disabled', true);
                    streetInput.attr('data-ref', '');
                    streetInput.val('');

                    if($(this).val().length < 3) {
                        setTimeout(function() {
                            addressDrop.removeClass(activeClass);
                        },0)
                        return;
                    } else {
                        findAddress($(this).val());
                        addressDrop.addClass(activeClass);
                    }
                });

                addressList.on( "click", "a", function(e) {
                    e.preventDefault();
                    addressInput.val($(this).text());
                    addressInput.attr('data-ref', $(this).attr('data-ref'));
                    streetInput.attr('disabled', false);
                    streetInput.attr('data-ref', '');
                    streetInput.val('');
                    addressDrop.removeClass(activeClass);
                    $("#checkout-form").data("validator").currentElements.valid();
                });

                streetInput.on('focus', function(){
                    streetDrop.addClass(activeClass);
                    findStreet(addressInput.attr('data-ref'));
                });

                streetInput.on('blur', function() {
                    setTimeout(function() {
                        streetDrop.removeClass(activeClass);
                    },0);
                });

                streetInput.on('input', function() {
                    streetInput.attr('data-ref', '');
                    findStreet(addressInput.attr('data-ref'), this.value);
                });

                function findStreet(CityRef, FindByString) {
                    var methodProperties = {
                        "Limit" : "200",
                        "Page" : "1"
                    }

                    if(CityRef) {
                        methodProperties.CityRef = CityRef
                    }
                    if(FindByString) {
                        methodProperties.FindByString = FindByString
                    }

                    $.post(
                        'https://api.novaposhta.ua/v2.0/json/',
                        JSON.stringify({
                            "apiKey": "cd1636968f2a5dbb0ab40e326cf258de",
                            "modelName": "Address",
                            "calledMethod": "getStreet",
                            "methodProperties" : methodProperties
                        }),
                        function(data){
                            streetList.html('');
                            if(!data.data?.length) {
                                streetList.append('<li><span>Немає результатів</span></li>');
                            } else {
                                data.data.forEach(function(item) {
                                    streetList.append('<li><a href="#" data-ref="'+ item.Ref +'">'+ item.StreetsType +' '+ item.Description +'</a></li>');
                                });
                            }
                        }
                    );
                }

                streetList.on( "click", "a", function(e) {
                    e.preventDefault();
                    streetInput.val($(this).text());
                    streetInput.attr('data-ref', $(this).attr('data-ref'));
                    streetDrop.removeClass(activeClass);
                    $("#checkout-form").data("validator").currentElements.valid();
                });
            }

        };

        radios.each(function () {
            if ($(this).is(':checked')) {
                if (checkEqual($(this), 'NovaPoshtaMailbox')) {
                    checkRadio().not(':radio[data-value="BankCard"]').each(function () {
                        disablingRadio($(this));
                        ResetPayment();
                    });

                    NovaPoshtaHandler($('#NovaPoshtaMailboxAddress'), $('#NovaPoshtaMailboxDepartment'));
                }
                if (checkEqual($(this), 'OwnCourier')) {
                    checkRadio().not(', :radio[data-value="BankCard"], :radio[data-value="Cash"]').each(function () {
                        disablingRadio($(this));
                        ResetPayment();
                    });
                }
                if (checkEqual($(this), 'NovaPoshtaОffice')) {
                    checkRadio().not(isDisablePayByCardCase).each(function () {
                        disablingRadio($(this));
                        ResetPayment();
                    });

                    NovaPoshtaHandler($('#NovaPoshtaOfficeAddress'), '', $('#NovaPoshtaOfficeDepartment'));
                }
                if (checkEqual($(this), 'NovaPoshtaDelivery')) {
                    checkRadio().not(isDisablePayByCardCase).each(function () {
                        disablingRadio($(this));
                        ResetPayment();
                    });

                    NovaPoshtaHandler($("#NovaPoshtaDeliveryAddress"), '', '', $('#NovaPoshtaDeliveryStreet'));
                }

                if (checkEqual($(this), 'JustinOffice')) {
                    checkRadio().not(isDisablePayByCardCase).each(function () {
                        disablingRadio($(this));
                        ResetPayment();
                    });
                }
                if (checkEqual($(this), 'UkrposhtaOffice')) {
                    checkRadio().not((isDisablePayByCard ? '' : ':radio[data-value="Fondy"],') + ':radio[data-value="BankCard"]').each(function () {
                        disablingRadio($(this));
                        ResetPayment();
                    });
                }
                if (checkEqual($(this), 'Pickup')) {
                    checkRadio().not((isDisablePayByCard ? '' : ':radio[data-value="Fondy"],') + ':radio[data-value="BankCard"], :radio[data-value="Cash"]').each(function () {
                        disablingRadio($(this));
                        ResetPayment();
                    });
                }
                if (checkEqual($(this), 'InternationalDelivery')) {
                    checkRadio().not(':radio[data-value="BankCard"]').each(function () {
                        disablingRadio($(this));
                        ResetPayment();
                    });
                }
            }

        });
    }
}

function checkPromoCode(code) {
    $(".correct-promo-code-label").hide();
    $(".incorrect-promo-code-label").hide();
    $(".promo-code").addClass("promo-top-margin");

    $.ajax({
        method: "GET",
        url: '/umbraco/surface/checkout/calculateTotalWithPromoCode?code=' + code
    }).done(function (result) {
        $.ajax({
            mehod: 'GET',
            url: '/umbraco/surface/checkout/basketSummary'
        }).done(function (basketSummaryHtml) {
            var fragment = document.createElement('html');
            fragment.innerHTML = basketSummaryHtml;

            $('.summary-table').replaceWith(fragment.querySelector('table').outerHTML);

            if (result && result.IsActive) {
                calculateTotal(result.CalculationTotal);
                $(".promo-code-total-container").show();
                $(".js-total-basket-value").addClass('basket-old-price');
                $(".correct-promo-code-label").show();
                $('#PromoCode').val(code);
                showPromocode();
            } else {
                $(".js-total-basket-value").removeClass('basket-old-price');
                $(".promo-code-total-container").hide();
                $(".incorrect-promo-code-label").show();
                $('#PromoCode').val('');
                hidePromocode();
            }
            $(".promo-code").removeClass("promo-top-margin");
        });
    });
}

function setEmailAddressInReceipt() {
    var emailContainer = $('.order__email');

    if (!emailContainer) return;

    var orderData = localStorage.getItem('checkoutForm');

    if (!orderData) return;

    var emailField = JSON.parse(orderData).fields.find(function (item) { return item.name === "Email"; });
    emailContainer.text(emailField.value);

}

setEmailAddressInReceipt();

function setCheckedPromoCode(checked) {
    $.ajax({
        method: "GET",
        url: '/umbraco/surface/checkout/haspromocode?isChecked=' + checked
    });
}

// function calculateTotal() {
//     if (window.promoCodePercent) {
//         var oldTotal = parseFloat($('.js-total-price').text());
//         var discountPrice = oldTotal * window.promoCodePercent / 100;
//         var toPay = oldTotal - discountPrice;
//         var currency = $('#Currency').val();
//         let descountPriceHtml = discountPrice.toFixed(2).replace('.', ',') + ' <span class="val">' + currency + '</span>';
//         $('.js-promocode-discount-price').html(descountPriceHtml);
//         $('.js-to-pay-value').html(toPay.toFixed(2).replace('.', ',') + ' <span class="val">' + currency + '</span>');
//         var TotalLabel = window.location.pathname.split('/')[1] == 'ru' ? 'ИТОГО:' : window.location.pathname.split('/')[1] == 'en' ? 'total' : 'РАЗОМ';
//         $('.js-total-title').text(TotalLabel);
//     }
// }

function hidePromocode() {
    $('.js-hidden-promo').addClass('hidden');
}

$('.radio').on('click', function () {
    var paymentType = $(this).text();
    var goToPayment = translations.goToPayment[getLanguageForTranslations()];
    var checkout = translations.checkout[getLanguageForTranslations()];
    var buttonText = paymentType.trim().includes('Оплата онлайн') ? goToPayment : checkout;

    $('#PaymentType').val(buttonText);
})

function showPromocode() {
    $('.js-hidden-promo').removeClass('hidden');
}
var BillingForm = function (form, config) {
    var self = this;

    this.$form = $(form);
    this.activeClass = "active";
    this.disabledClass = "disabled";
    this.exceptedFields = config.exceptedFields;
    this.storageName = config.storageName;

    this.states = {
        disabled: "disabled",
        activated: "activated",
        filled: "filled"
    };

    this.$tabsHolder = $('.js-billing');
    this.$tabsContent = $('#checkout-form .tabs__content');
    this.$tabsNav = $('#billing-form-anchor .js-tabs__item');
    this.$tabsPrev = $('#billing-form-anchor .js-tabs__prev');
    this.$tabsToStep = $('#billing-form-anchor .js-go-to-step');

    this.checkoutState = {
        activeTabIdx: 0,
        tabs: this.$tabsContent.map(function (idx, obj) {
            return idx == 0 ? self.states.activated : self.states.disabled;
        }).get(),
        fields: this.$form.serializeArray().filter(function (item) {
            return !self.exceptedFields.includes(item.name);
        })
    };
    this.init();
};

BillingForm.prototype.GeEventUserInfo = function () {
    var userInfoKeys = ['FirstName', 'LastName', 'Phone', 'Patronymic', 'Email', 'Instagram'];
    var userInfo = [];
}

BillingForm.prototype.GetPaymentInfo = function () {
    var paymentInfoKeys = ['delivery', 'paymentMethod', 'reciever', 'DontCallback', 'Region', 'City', 'Department'];
    var paymentInfo = [];
}

BillingForm.prototype.checkPayment = function () {

    var localStore = this.getState();

    if (!localStore) return;

    var fields = localStore.fields;
    var isAllowCod = parseInt($('.js-total-price').text(), 0) >= 300 && $('#DisablePayByCod').length <= 0;
    var isAllowPayByCard = parseInt($('.js-total-price').text(), 0) >= 200;
    var DisablePaymentByCard = isAllowPayByCard ? $('#DisableCardPay').length > 0 : true;
    var radios = $('input[name = payment-selector]');
    var currentPaymentMethod = $('#paymentMethod').val();
    var delivery = $('#delivery').val();
    if (jcf) {
        jcf.refreshAll('#checkout-form');
    }

    if (currentPaymentMethod) {
        if (!isAllowCod && currentPaymentMethod == 'COD' || DisablePaymentByCard && currentPaymentMethod == 'Fondy' || delivery == 'InternationalDelivery') {
            radios.each(function () {
                if ($(this).data().value == 'BankCard') {
                    $(this).attr('checked', true);
                    $(this).parent().removeClass('jcf-unchecked');
                    $(this).parent().addClass('jcf-checked');
                    $('#paymentMethod').val('BankCard');
                } else {
                    $(this).removeAttr('checked');
                    $(this).parent().removeClass('jcf-checked');
                    $(this).parent().addClass('jcf-unchecked');
                }
            });
        } else {
            radios.each(function () {
                if ($(this).data().value == currentPaymentMethod) {
                    $(this).attr('checked', true);
                    $(this).parent().removeClass('jcf-unchecked');
                    $(this).parent().addClass('jcf-checked');
                } else {
                    $(this).removeAttr('checked');
                    $(this).parent().removeClass('jcf-checked');
                    $(this).parent().addClass('jcf-unchecked');
                }
            });
        }
    }
}

BillingForm.prototype.init = function () {
    var self = this;

    var savedCheckoutState = this.getState();

    if (savedCheckoutState) {
        var phone = savedCheckoutState.fields.find(function (v) { return v.name === 'Phone'; });
        var visualPhone = savedCheckoutState.fields.indexOf(phone) + 1;

        if (phone &&
            (savedCheckoutState.fields[visualPhone].name !== 'visual-phone-number' ||
                !savedCheckoutState.fields[visualPhone].value ||
                savedCheckoutState.fields[visualPhone].value.length < 1)
        ) {
            phone.value = null;
            if (savedCheckoutState.fields[visualPhone].name === 'visual-phone-number') {
                savedCheckoutState.fields[visualPhone].value = null;
            }
            savedCheckoutState.activeTabIdx = 0;
        }

        if (phone.value.includes('+380380')) {
            phone.value = phone.value.replaceAll('+380380', '+380');
        }

        var recieverPhone = savedCheckoutState.fields.find(function (v) { return v.name === 'RecieverPhone'; });
        var visualRecieverPhone = savedCheckoutState.fields.indexOf(recieverPhone) + 1;

        if (recieverPhone &&
            (savedCheckoutState.fields[visualRecieverPhone].name !== 'visual-phone-number' ||
                !savedCheckoutState.fields[visualRecieverPhone].value ||
                savedCheckoutState.fields[visualRecieverPhone].value.length < 1)
        ) {
            recieverPhone.value = null;
            if (savedCheckoutState.fields[visualRecieverPhone].name === 'visual-phone-number') {
                savedCheckoutState.fields[visualRecieverPhone].value = null;
            }
            savedCheckoutState.activeTabIdx = savedCheckoutState.activeTabIdx === 0 ? savedCheckoutState.activeTabIdx : 1;
        }

        if (recieverPhone && recieverPhone.value.includes('+380380')) {
            recieverPhone.value = recieverPhone.value.replaceAll('+380380', '+380');
        }

        localStorage.setItem(this.storageName, JSON.stringify(savedCheckoutState));

        this.checkoutState = savedCheckoutState;
        $.each(savedCheckoutState.fields, function (i, field) {
            var $input = self.$form.find("[name='" + field.name + "']");
            var type = $input.attr('type');

            if (type == 'radio' || type == 'checkbox') {

                var target = $input.filter(function (idx, el) {
                    return (el.getAttribute('data-value') || el.getAttribute('value')) == field.value;
                });
                target.prop('checked', true);

            } else if (type === 'select') {
                $input.val(field.value);
                $input.trigger('change');
            }
            else {
                var input = self.$form.find("[name='" + field.name + "']");
                input.val(field.value);

                var ref = field["data-ref"];
                if(ref) {
                    input.attr("data-ref", ref);
                    input.attr("disabled", false);
                }
            }
        });

        var preferredMessenger = savedCheckoutState.fields.find(function (v) { return v.name === 'PreferredMessenger'; });

        if (preferredMessenger) {
            ValidateField('Telegram', 'Telegram');
            ValidateField('Instagram', 'Instagram');

            function ValidateField(fieldName, preferredMessengerValue) {
                var field = savedCheckoutState.fields.find(function (v) { return v.name === fieldName; });

                if (preferredMessenger?.value === preferredMessengerValue && (!field || !field.value)) {
                    savedCheckoutState.activeTabIdx = 0;
                }
            }
        }

        if (jcf) {
            jcf.refreshAll(this.$form);
        }

        this.useState();
    }

    else {
        var deliveryValue = $('#delivery').val()
        var field = this.$form.find("[name = 'delivery-selector']").filter(function (idx, el) {
            return (el.getAttribute('data-value') || el.getAttribute('value')) == deliveryValue;
        });

        field.prop('checked', true);
    }

    this.$tabsContent.hide().eq(this.checkoutState.activeTabIdx).show();
    this.$tabsNav.removeClass(this.activeClass).eq(this.checkoutState.activeTabIdx).addClass(this.activeClass);

    $.each(this.checkoutState.tabs, function (i, tab) {
        if (tab != self.states.disabled) {
            self.$tabsNav.eq(i).removeClass(self.disabledClass);
        }
    });

    this.$tabsContent.on('click', '.js-next-step-btn', function () {
        self.toStep(self.checkoutState.activeTabIdx + 1);
        $(".js-submit-checkout").val($("#PaymentType").val());
        window.scrollTo(0, 0);
    });

    $('#EditButton').on('click', function () {
        self.toStep(self.checkoutState.activeTabIdx, true);
    });

    this.$tabsNav.on('click', function () {
        const idx = self.$tabsNav.index(this);

        if (self.checkoutState.tabs[idx] !== self.states.disabled) {
            self.toStep(idx);
        }
    });

    this.$tabsPrev.on('click', function (e) {
        e.preventDefault();
        const idx = self.$tabsPrev.index(this);

        if (self.checkoutState.tabs[idx] !== self.states.disabled) {
            self.toStep(idx);
        }
    });

    this.$tabsToStep.on('click', function (e) {
        e.preventDefault();
        const idx = self.$tabsToStep.index(this);

        if (self.checkoutState.tabs[idx] !== self.states.disabled) {
            self.toStep(idx);
        }
    });
};

BillingForm.prototype.toStep = function (toStepIdx, validationIsUnnecessary) {
    var self = this;
    const activeTabIdx = this.checkoutState.activeTabIdx;
    const statusOfLeaveTab = this.checkoutState.tabs[activeTabIdx];
    const statusOfTargetTab = this.checkoutState.tabs[toStepIdx];
    const skeepValidate = statusOfLeaveTab == this.states.activated && statusOfTargetTab == this.states.filled;


    if (skeepValidate || (!validationIsUnnecessary && this.$form.valid())) {
        this.checkoutState.tabs[activeTabIdx] = this.states.filled;

        if (this.checkoutState.tabs[toStepIdx] == this.states.disabled) {
            this.checkoutState.tabs[toStepIdx] = this.states.activated;
        }

        this.checkoutState.fields = this.formSerializeArray();

        if (this.checkoutState.activeTabIdx == 0 && toStepIdx == 1) {
            this.GeEventUserInfo();
        }

        this.checkoutState.activeTabIdx = toStepIdx;
        this.checkPayment();
        this.saveState();
        this.useState();
        this.$tabsContent.eq(activeTabIdx).hide();
        this.$tabsContent.eq(toStepIdx).show();


        this.$tabsNav.eq(activeTabIdx).removeClass(this.activeClass);
        this.$tabsNav.eq(toStepIdx).addClass(this.activeClass).removeClass(this.disabledClass);
    }
};

BillingForm.prototype.formSerializeArray = function () {
    var self = this;

    var serializeStr = BillingForm.serialize(this.$form.get(0));

    serializeStr = serializeStr.map(function (el) {
        if (self.checkoutState.activeTabIdx == 1 && el.name == "Comment") {
            el.value = serializeStr.find(function (item) { return item.name == "Comment2" }).value;
            return el;
        }
        else if (self.checkoutState.activeTabIdx == 2 && (el.name == "Comment" || el.name == "Comment2")) {
            el.value = serializeStr.find(function (item) { return item.name == "Comment3" }).value;
            return el;
        }

        return el;
    });

    var elements = serializeStr.filter(function (el) {
        return el.value && !self.exceptedFields.includes(el.name);
    });

    return elements;
};

BillingForm.serialize = function (form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1) return;
        if (field.type === 'select-multiple') {
            Array.prototype.slice.call(field.options).forEach(function (option) {
                if (!option.selected) return;
                arr.push({ name: field.name, value: option.value });
            });
            return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked) return;
        var el = {
            name: field.name,
            value: field.getAttribute('data-value') || field.value,
        };

        if(["NovaPoshtaMailboxAddress", "NovaPoshtaOfficeAddress", "NovaPoshtaDeliveryAddress", "NovaPoshtaMailboxDepartment", "NovaPoshtaOfficeDepartment", "NovaPoshtaDeliveryStreet"].includes(el.name)){
            el["data-ref"] = field.getAttribute('data-ref');
        }
        arr.push(el);
    });
    return arr;
};

BillingForm.prototype.saveState = function () {
    var isAllowCod = parseInt($('.js-total-price').text(), 0) >= 300 && $('#DisablePayByCod').length <= 0;
    var isAllowPayByCard = parseInt($('.js-total-price').text(), 0) >= 200;
    var currentPaymentMethod = $('#checkout-form').get(0)['paymentMethod'].value;
    var currentDelivery = $('#checkout-form').get(0)['delivery'].value;
    var isDisablePayByCard = isAllowPayByCard ? $('#DisableCardPay').length > 0 : true;

    for (var key in this.checkoutState.fields) {
        this.checkoutState.fields[key].value = this.checkoutState.fields[key].value.trim();
    }

    if (!isAllowCod && currentPaymentMethod == 'COD' || currentPaymentMethod == 'Fondy' && isDisablePayByCard || currentDelivery == "InternationalDelivery") {
        this.checkoutState.fields[1].value = 'BankCard';
    }

    localStorage.setItem(this.storageName, JSON.stringify(this.checkoutState));

};

$(document).ready(function () {

    var goToPayment = translations.goToPayment[getLanguageForTranslations()];
    var checkout = translations.checkout[getLanguageForTranslations()];

    var buttonText = $('.order-info__payment').text().trim().includes('Оплата онлайн') ? goToPayment : checkout;

    $('.js-submit-checkout').val(buttonText);
})

BillingForm.prototype.getState = function () {
    var state = localStorage.getItem(this.storageName);

    if (state) {
        try {
            return JSON.parse(state);
        } catch (error) {
            console.error(error);
        }
    }
};

BillingForm.prototype.resetState = function () {
    localStorage.removeItem(this.storageName);
};

BillingForm.prototype.useState = function () {
    var rawdata = localStorage.getItem('checkoutForm');
    var fields;

    if (rawdata) {
        try {
            fields = JSON.parse(rawdata).fields;
        }
        catch (error) {
            console.error(error);
        }

        if (Array.isArray(fields)) {
            var nameInfoBlock = $('.order-info__name');
            var contactsInfoBlock = $('.order-info__contacts');
            var deliveryInfoBlock = $('.order-info__delivery');
            var addressInfoBlock = $('.order-info__address');
            var paymentInfoBlock = $('.order-info__payment');

            var firsNameField = fields.find(function (field) { return field.name == "FirstName" });
            var patronymicField = fields.find(function (field) { return field.name == "Patronymic" });
            var lastNameField = fields.find(function (field) { return field.name == "LastName" });
            var phoneField = fields.find(function (field) { return field.name == "Phone" });
            var messengerField = fields.find(function (field) { return field.name == "PreferredMessenger" });
            var emailField = fields.find(function (field) { return field.name == "Email" });
            var commentField = fields.find(function (field) { return field.name == "Comment" });


            var deliveryField = fields.find(function (field) { return field.name == "delivery" });

            var isInternationalDelivery = deliveryField.value == "InternationalDelivery";

            var countryField = fields.find(function (field) { return field.name == "Country" });

            var novaPoshtaMailboxAddressField = fields.find(function (field) { return field.name == "NovaPoshtaMailboxAddress" });
            var novaPoshtaOfficeAddressField = fields.find(function (field) { return field.name == "NovaPoshtaOfficeAddress" });
            var novaPoshtaAddressField = fields.find(function (field) { return field.name == "NovaPoshtaDeliveryAddress" });
            var novaPoshtaMailboxField = fields.find(function (field) { return field.name == "NovaPoshtaMailboxDepartment" });
            var novaPoshtaOfficeField = fields.find(function (field) { return field.name == "NovaPoshtaOfficeDepartment" });
            var novaPoshtaStreetField = fields.find(function (field) { return field.name == "NovaPoshtaDeliveryStreet" });

            var regionField = fields.find(function (field) { return field.name == "Region" });
            var cityField = fields.find(function (field) { return isInternationalDelivery ? field.name == "InternationalCity" : field.name == "City" });
            var streetField = fields.find(function (field) { return isInternationalDelivery ? field.name == "InternationalStreet" : field.name == "Street" });
            var houseNumberField = fields.find(function (field) { return isInternationalDelivery ? field.name == "InternationalHouse" : field.name == "HouseNumber" });
            var flatNumberField = fields.find(function (field) { return field.name == "FlatNumber" });
            var DepartmentField = fields.find(function (field) { return field.name == "Department" });

            if (DepartmentField == null) {
                DepartmentField = fields.find(function (field) { return field.name == "Adress" });
            }

            var indexField = fields.find(function (field) { return field.name == "Index" });

            var paymentField = fields.find(function (field) { return field.name == "paymentMethod" });
            if (commentField) {
                $('#Comment').val(commentField.value);
                $('#Comment2').val(commentField.value);
                $('#Comment3').val(commentField.value);
            }
            var isAllowCod = parseInt($('.js-total-price').text(), 0) >= 300 && $('#DisablePayByCod').length <= 0;
            var isAllowPayByCard = parseInt($('.js-total-price').text(), 0) >= 200;
            var isDisablePayByCard = isAllowPayByCard ? $('#DisableCardPay').length > 0 : true;
            var checkoutForm = $('#checkout-form');
            if (checkoutForm.length > 0) {
                var currentPaymentMethod = checkoutForm.get(0)['paymentMethod'].value;
                var currentDelivery = checkoutForm.get(0)['delivery'].value;
                if (!isAllowCod && currentPaymentMethod == 'COD' || isDisablePayByCard && currentPaymentMethod == 'Fondy' || currentDelivery == "InternationalDelivery") {
                    paymentField.value = 'BankCard';
                }
            }
            var nameBlock = $('.order-info__name .details__name');
            if (firsNameField) {
                if (nameBlock.length) {
                    nameBlock.replaceWith("<span class='details__name'>" + firsNameField.value + ' ' + "</span>");
                } else {
                    nameInfoBlock.append("<span class='details__name'>" + firsNameField.value + ' ' + "</span>");
                }
            } else if (nameBlock) {
                nameBlock.html("");
            }

            var patronymicBlock = $('.order-info__name .details__patronymic');
            if (patronymicField) {
                if (patronymicBlock.length) {
                    patronymicBlock.replaceWith("<span class='details__patronymic'>" + patronymicField.value + ' ' + "</span>");
                } else {
                    nameInfoBlock.append("<span class='details__patronymic'>" + patronymicField.value + ' ' + "</span>");
                }
            } else if (patronymicBlock) {
                patronymicBlock.html("");
            }

            var lastNameBlock = $('.order-info__name .details__last-name');
            if (lastNameField) {
                if (lastNameBlock.length) {
                    lastNameBlock.replaceWith("<span class='details__last-name'>" + lastNameField.value + ',' + "</span>");
                } else {
                    nameInfoBlock.append("<span class='details__last-name'>" + lastNameField.value + ',' + "</span>");
                }
            } else if (lastNameBlock) {
                lastNameBlock.html("");
            }

            var phoneBlock = $('.order-info__contacts .details__phone');
            if (phoneField) {
                if (phoneBlock.length) {
                    phoneBlock.replaceWith("<span class='details__phone'>" + phoneField.value + ' ' + "</span>");
                } else {
                    contactsInfoBlock.append("<span class='details__phone'>" + phoneField.value + ' ' + "</span>");
                }
            } else if (phoneBlock) {
                phoneBlock.html("");
            }

            var messengerBlock = $('.order-info__contacts .details__messenger');
            if (messengerField) {
                if (messengerBlock.length) {
                    messengerBlock.replaceWith("<span class='details__messenger'>, " + messengerField.value + ' ' + "</span>");
                } else {
                    contactsInfoBlock.append("<span class='details__messenger'>, " + messengerField.value + ' ' + "</span>");
                }
            } else if (messengerBlock) {
                messengerBlock.html("");
            }

            var emailBlock = $('.order-info__contacts .details__email');
            if (emailField) {
                if (emailBlock.length) {
                    emailBlock.replaceWith("<span class='details__email'>, " + emailField.value + ' ' + "</span>");
                } else {
                    contactsInfoBlock.append("<span class='details__email'>, " + emailField.value + ' ' + "</span>");
                }
            } else if (emailBlock) {
                emailBlock.html("");
            }

            if (deliveryField) {
                deliveryInfoBlock.html($("input[data-value='" + deliveryField.value + "']").closest('label').text());
            }

            var novaPoshtaMailboxAddressBlock = $('.order-info__address .details__nova_poshta_mailbox_address');
            if (novaPoshtaMailboxAddressField) {
                if (novaPoshtaMailboxAddressBlock.length) {
                    novaPoshtaMailboxAddressBlock.replaceWith("<span class='details__nova_poshta_mailbox_address'>" + novaPoshtaMailboxAddressField.value + ', ' + "</span>");
                } else {
                    addressInfoBlock.prepend("<span class='details__nova_poshta_mailbox_address'>" + novaPoshtaMailboxAddressField.value + ', ' + "</span>");
                }
            } else if (novaPoshtaMailboxAddressBlock) {
                novaPoshtaMailboxAddressBlock.html("");
            }

            var novaPoshtaOfficeAddressBlock = $('.order-info__address .details__nova_poshta_office_address');
            if (novaPoshtaOfficeAddressField) {
                if (novaPoshtaOfficeAddressBlock.length) {
                    novaPoshtaOfficeAddressBlock.replaceWith("<span class='details__nova_poshta_office_address'>" + novaPoshtaOfficeAddressField.value + ', ' + "</span>");
                } else {
                    addressInfoBlock.prepend("<span class='details__nova_poshta_office_address'>" + novaPoshtaOfficeAddressField.value + ', ' + "</span>");
                }
            } else if (novaPoshtaOfficeAddressBlock) {
                novaPoshtaOfficeAddressBlock.html("");
            }

            var novaPoshtaAddressBlock = $('.order-info__address .details__nova_poshta_address');
            if (novaPoshtaAddressField) {
                if (novaPoshtaAddressBlock.length) {
                    novaPoshtaAddressBlock.replaceWith("<span class='details__nova_poshta_address'>" + novaPoshtaAddressField.value + ', ' + "</span>");
                } else {
                    addressInfoBlock.prepend("<span class='details__nova_poshta_address'>" + novaPoshtaAddressField.value + ', ' + "</span>");
                }
            } else if (novaPoshtaAddressBlock) {
                novaPoshtaAddressBlock.html("");
            }

            var novaPoshtaMailboxBlock = $('.order-info__address .details__nova_poshta_mailbox');
            if (novaPoshtaMailboxField) {
                if (novaPoshtaMailboxBlock.length) {
                    novaPoshtaMailboxBlock.replaceWith("<span class='details__nova_poshta_mailbox'>" + novaPoshtaMailboxField.value + "</span>");
                } else {
                    addressInfoBlock.append("<span class='details__nova_poshta_mailbox'>" + novaPoshtaMailboxField.value + "</span>");
                }
            } else if (novaPoshtaMailboxBlock) {
                novaPoshtaMailboxBlock.html("");
            }

            var novaPoshtaOfficeBlock = $('.order-info__address .details__nova_poshta_office');
            if (novaPoshtaOfficeField) {
                if (novaPoshtaOfficeBlock.length) {
                    novaPoshtaOfficeBlock.replaceWith("<span class='details__nova_poshta_office'>" + novaPoshtaOfficeField.value + "</span>");
                } else {
                    addressInfoBlock.append("<span class='details__nova_poshta_office'>" + novaPoshtaOfficeField.value + "</span>");
                }
            } else if (novaPoshtaOfficeBlock) {
                novaPoshtaOfficeBlock.html("");
            }

            var novaPoshtaStreetBlock = $('.order-info__address .details__nova_poshta_street');
            if (novaPoshtaStreetField) {
                if (novaPoshtaStreetBlock.length) {
                    novaPoshtaStreetBlock.replaceWith("<span class='details__nova_poshta_street'>" + novaPoshtaStreetField.value + "</span>");
                } else {
                    addressInfoBlock.append("<span class='details__nova_poshta_street'>" + novaPoshtaStreetField.value + "</span>");
                }
            } else if (novaPoshtaStreetBlock) {
                novaPoshtaStreetBlock.html("");
            }

            var indexBlock = $('.order-info__address .details__index');

            if (indexField) {
                if (indexBlock.length) {
                    indexBlock.replaceWith("<span class='details__index'>" + indexField.value + ' ' + "</span>");
                } else {
                    addressInfoBlock.append("<span class='details__index'>" + indexField.value + ' ' + "</span>");
                }
            } else if (indexBlock) {
                indexBlock.html("");
            }

            var countryBlock = $('.order-info__address .details__country');

            if (countryField) {
                if (countryBlock.length) {
                    countryBlock.replaceWith("<span class='details__country'>, " + countryField.value + ' ' + "</span>");
                } else {
                    addressInfoBlock.append("<span class='details__country'>, " + countryField.value + ' ' + "</span>");
                }
            } else if (countryBlock) {
                countryBlock.html("");
            }

            var regionBlock = $('.order-info__address .details__region');

            if (regionField) {
                if (regionBlock.length) {
                    regionBlock.replaceWith("<span class='details__region'>, " + regionField.value + ' ' + "</span>");
                } else {
                    addressInfoBlock.append("<span class='details__region'>, " + regionField.value + ' ' + "</span>");
                }
            } else if (regionBlock) {
                regionBlock.html("");
            }

            var cityBlock = $('.order-info__address .details__city');
            if (cityField) {
                if (cityBlock.length) {
                    cityBlock.replaceWith("<span class='details__city'>, " + cityField.value + ' ' + "</span>");
                } else {
                    addressInfoBlock.append("<span class='details__city'>, " + cityField.value + ' ' + "</span>");
                }
            } else if (cityBlock) {
                cityBlock.html("");
            }

            if (!cityField && deliveryField.value == 'OwnCourier') {
                addressInfoBlock.html("");
                addressInfoBlock.append("<span class='details__city'>Харьков</span>");
            }

            var departmentBlock = $('.order-info__address .details__department');

            if (DepartmentField) {
                if (departmentBlock.length) {
                    departmentBlock.replaceWith("<span class='details__department'>, " + DepartmentField.value + ' ' + "</span>");
                } else {
                    addressInfoBlock.append("<span class='details__department'>, " + DepartmentField.value + ' ' + "</span>");
                }
            }
            else if (departmentBlock) {
                departmentBlock.html("");
            }

            var streetBlock = $('.order-info__address .details__street');
            if (streetField) {
                if (streetBlock.length) {
                    streetBlock.replaceWith("<span class='details__street'>, " + streetField.value + ' ' + "</span>");
                } else {
                    addressInfoBlock.append("<span class='details__street'>, " + streetField.value + ' ' + "</span>");
                }
            } else if (streetBlock) {
                streetBlock.html("");
            }

            var houseNumberBlock = $('.order-info__address .details__house');
            if (houseNumberField) {
                if (houseNumberBlock.length) {
                    houseNumberBlock.replaceWith("<span class='details__house'>, " + houseNumberField.value + ' ' + "</span>");
                } else {
                    addressInfoBlock.append("<span class='details__house'>, " + houseNumberField.value + ' ' + "</span>");
                }
            } else if (houseNumberBlock) {
                houseNumberBlock.html("");
            }

            var flatNumberBlock = $('.order-info__address .details__flat');
            if (flatNumberField) {
                if (flatNumberBlock.length) {
                    flatNumberBlock.replaceWith("<span class='details__flat'>, " + flatNumberField.value + ' ' + "</span>");
                } else {
                    addressInfoBlock.append("<span class='details__flat'>, " + flatNumberField.value + ' ' + "</span>");
                }
            } else if (flatNumberBlock) {
                flatNumberBlock.html("");
            }

            var goToPayment = translations.goToPayment[getLanguageForTranslations()];
            var checkout = translations.checkout[getLanguageForTranslations()];

            if (paymentField) {
                $('.js-submit-checkout').val(paymentField.value === 'Fondy' ? goToPayment : checkout);

                paymentInfoBlock.html($("input[data-value='" + paymentField.value + "']").closest('label').text());
                $("#PaymentType").val($('.js-submit-checkout').val());
            }

            var receiver = fields.find(function (field) { return field.name == "reciever" });
            if (receiver.value === 'OtherPerson') {

                var receiverNameInfoBlock = $('.order-info__receiver-name');
                var receiverContactsInfoBlock = $('.order-info__receiver-contacts');

                var anotherPeopleFirsNameField = fields.find(function (field) { return field.name == "RecieverFirstName" });
                var anotherPeopleLastNameField = fields.find(function (field) { return field.name == "RecieverLastName" });
                var anotherPeoplePhoneField = fields.find(function (field) { return field.name == "RecieverPhone" });

                var receiverNameBlock = $('.order-info__receiver-name .details__receiver-name');
                if (anotherPeopleFirsNameField) {
                    if (receiverNameBlock.length) {
                        receiverNameBlock.replaceWith("<span class='details__receiver-name'>" + anotherPeopleFirsNameField.value + ' ' + "</span>");
                    } else {
                        receiverNameInfoBlock.append("<span class='details__receiver-name'>" + anotherPeopleFirsNameField.value + ' ' + "</span>");
                    }
                } else if (receiverNameBlock) {
                    receiverNameBlock.html("");
                }

                var receiverLastNameBlock = $('.order-info__receiver-name .details__receiver-last-name');
                if (anotherPeopleLastNameField) {
                    if (receiverLastNameBlock.length) {
                        receiverLastNameBlock.replaceWith("<span class='details__receiver-last-name'>" + anotherPeopleLastNameField.value + ',' + "</span>");
                    } else {
                        receiverNameInfoBlock.append("<span class='details__receiver-last-name'>" + anotherPeopleLastNameField.value + ',' + "</span>");
                    }
                } else if (receiverLastNameBlock) {
                    receiverLastNameBlock.html("");
                }

                var receiverPhoneBlock = $('.order-info__receiver-contacts .details__receiver-phone');
                if (anotherPeoplePhoneField) {
                    if (receiverPhoneBlock.length) {
                        receiverPhoneBlock.replaceWith("<span class='details__receiver-phone'>" + anotherPeoplePhoneField.value + ' ' + "</span>");
                    } else {
                        receiverContactsInfoBlock.append("<span class='details__receiver-phone'>" + anotherPeoplePhoneField.value + ' ' + "</span>");
                    }
                } else if (receiverPhoneBlock) {
                    receiverPhoneBlock.html("");
                }

                receiverNameInfoBlock.parent().show();
            }
            else {
                $('.order-info__receiver-name').parent().hide();
            }
        }
    }
    //JSON.parse(localStorage.getItem('checkoutForm')).fields.find(function(field){return field.name == "Street"}).value
}
